import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { VisualWrapper } from "@/components/common/visual/visual.component";
import { MarketingPopupClose } from "./marketing-popup-close.component";
import { MarketingPopupContent } from "./marketing-popup-content.component";
import { popupVisual } from "./marketing-popup.types";
import type { MarketingPopupVariantProps } from "./marketing-popup.types";
export function MarketingPopupImmersive(t0) {
  const $ = _c(17);
  const {
    popup,
    className,
    onClose,
    onCtaClick
  } = t0;
  let t1;
  if ($[0] !== popup) {
    t1 = popupVisual(popup);
    $[0] = popup;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const visual = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("dark relative grid w-full max-w-2xl content-end overflow-hidden rounded-md bg-deep-sea-blue-800", "aspect-[4/5] tablet:aspect-[8/5]", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== visual) {
    t3 = visual && <VisualWrapper visual={visual} className="absolute inset-0 h-full w-full" visualClassName="h-full w-full" imgClassName="h-full w-full object-cover" asBackground={true} />;
    $[4] = visual;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="absolute inset-0 bg-gradient-to-b from-deep-sea-blue-900/0 from-30% to-deep-sea-blue-900/85 to-80%" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onClose) {
    t5 = <MarketingPopupClose className="bg-deep-sea-blue-900/40" onClick={onClose} />;
    $[7] = onClose;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onCtaClick || $[10] !== popup) {
    t6 = <MarketingPopupContent popup={popup} onCtaClick={onCtaClick} className="relative p-6 tablet:p-10" />;
    $[9] = onCtaClick;
    $[10] = popup;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t5 || $[15] !== t6) {
    t7 = <article className={t2} data-testid="marketing-popup-immersive">{t3}{t4}{t5}{t6}</article>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}